import {RouteRecordRaw} from "vue-router";
import InterviewInstanceLayoutView from "@/interview/views/InterviewInstanceLayoutView.vue";
import InterviewInstanceRecordView from "@/interview/views/InterviewInstanceRecordView.vue";
import InterviewConsumerProductTrackingView from "@/interview/views/InterviewConsumerProductTrackingView.vue";
import InterviewInstanceFinishedView from "@/interview/views/InterviewInstanceFinishedView.vue";
import InterviewInstanceSurveyView from "@/interview/views/InterviewInstanceSurveyView.vue";

const routes: RouteRecordRaw[] = [
    {
        path: '/interview-instances',
        name: 'interview-instances',
        component: InterviewInstanceLayoutView,
        meta: {
            layout: 'TheBlankLayout',
            transition: 'slide'
        },
        children: [
            {
                path: 'guideline',
                name: 'interview-instances.guideline',
                component: InterviewInstanceRecordView
            },
            {
                path: 'survey',
                name: 'interview-instances.survey',
                component: InterviewInstanceSurveyView
            },
            {
                path: 'consumer-product-tracking',
                name: 'interview-instances.consumer-product-tracking',
                component: InterviewConsumerProductTrackingView
            },
            {
                path: 'finished',
                name: 'interview-instances.finished',
                component: InterviewInstanceFinishedView
            }
        ]
    }
];

export default routes;
